module.exports = __webpack_public_path__ + "img/antes_despues_69.09380f5c.png";